import { faFileUpload } from '@fortawesome/free-solid-svg-icons';

export default {
  data() {
    return {
      icon: faFileUpload,
      file: null,
    };
  },
  methods: {
    handleFileUpload() {
      const selectedFile = this.$refs[this.fieldQuestionId].files[0];

      if (selectedFile !== undefined) {
        this.file = selectedFile;
      }

      // User clicked the input but click cancelled
      if (selectedFile === undefined) {
        this.file = null;
      }

      //eslint-disable-line
      this.$emit('change', this.file);
    },

    submitWithEnter() {
      this.handleFileUpload();

      this.goToNextQuestion();
    },
    /**
     * @link https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/file#attr-accept
     * @param question
     * @returns {string}
     */
    acceptedFileTypes(question) {
      return `${question.options.allowedExtensions},${question.options.allowedMimeTypes}`;
    },
    /**
     * @param maxFileSizeInBytes
     * @returns {string}
     */
    maxFileSizeAllowed(maxFileSizeInBytes) {
      if (maxFileSizeInBytes < 1024) {
        return `${maxFileSizeInBytes}bytes`;
      }

      if (maxFileSizeInBytes >= 1024 && maxFileSizeInBytes < 1048576) {
        return `${(maxFileSizeInBytes / 1024).toFixed(1)}KB`;
      }

      return `${(maxFileSizeInBytes / 1048576).toFixed(1)}MB`;
    },
    dragFile(event) {
      event.preventDefault();

      if (event.dataTransfer.files.length === 0) {
        return;
      }

      const fileInput = document.getElementById(this.fieldQuestionId);

      fileInput.files = event.dataTransfer.files;

      this.handleFileUpload();
    },
  },
};
